module.exports = __webpack_public_path__ + "img/car-2.0c70073c.jpg";